module.exports = __webpack_public_path__ + "static/media/logoMcCann.0d95eadf.png";